<template>
  <township-container toRoute="Volunteer"></township-container>
</template>

<script>
import TownshipContainer from "@/components/township/TownshipContainer.vue";
export default {
  components: {
    "township-container": TownshipContainer,
  },
};
</script>

